<template>
  <div id="IngredientsDish" v-bind="loading()">
    <div v-html="Obj.ingredientes" class="collection" style="margin-top: 0px !important;"></div>
  </div>
</template>
<script>
export default {
  name: "IngredientsDish",
  props: ["Obj"],
  data() {
    return {
      msg: "Ingredientes del Plato",
      prop: [
        {
          Obj: {
            fecha: Date,
            code: Number,
            name: String,
            desc: String,
            ingredientes: String,
            star: Float64Array,
            votos: Number,
            img: String,
            icon: String,
            Comments: [
              {
                fecha: Date,
                user: String,
                email: String,
                comments: String,
                star: Number
              }
            ]
          }
        }
      ]
    };
  },
  methods: {
    loading() {
    }
  }
};
</script>
<style scoped lang="css">
.collection {
    margin: 0rem 0 1rem 0 !important;
    border: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dish/IngredientsDish.vue